<div class="container header">
  <h3>Appointments</h3>
  <button type="button" class="btn btn-success btn13" routerLink="/doctorregister-member" >

    <span class="glyphicon glyphicon-plus"></span>Add Appointment</button>
</div>
<div class="container">
  <div class="col-lg-10 col-md-10 col-sm-10 col-xs-10">
    <ul class="nav nav-pills">

      <li><button type="button" data-toggle="tab" [ngClass]="appTypeString =='all'?'btn selectedBtn':'btn btn-primary'"
          (click)="getappName(appTypeString ='all')">All Appointments</button></li>
      <li><button type="button" data-toggle="tab"
          [ngClass]="appTypeString =='upcoming'?'btn selectedBtn':'btn btn-primary'"
          (click)="getappName(appTypeString ='upcoming')">Upcoming
          Appointments</button></li>
      <li><button type="button" [ngClass]="appTypeString =='cancel'?'btn selectedBtn':'btn btn-primary'"
          data-toggle="tab" (click)="getappName(appTypeString ='cancel')">Cancelled
          Appointments</button></li>
      <li><button type="button" [ngClass]="appTypeString =='reject'?'btn selectedBtn':'btn btn-primary'"
          data-toggle="tab" (click)="getappName(appTypeString ='reject')">Rejected
          Appointments</button></li>
    </ul>
  </div>
  <div class="col-lg-2 col-md-2 col-sm-2 col-xs-2">

    <div class="dropdown">
      <button class="btn btn-primary  dropdown-toggle btn12" type="button" id="dd" data-toggle="dropdown" data-a>Select Period
        <span class="caret"></span></button>
      <ul class="dropdown-menu" id="menu">
        <form [formGroup]="reqObj">
          <li>
            <label for="birthday">From:</label>
            <input type="text" id="fromDate" name="fromDate" placeholder="MM/DD/YYYY" formControlName="fromDate"
              [owlDateTimeTrigger]="dtRangeFrom" [owlDateTime]="dtRangeFrom">
            <owl-date-time #dtRangeFrom [pickerType]="'calendar'"></owl-date-time>
            <small class="err" *ngIf="reqObj.get('fromDate').hasError('required')&& reqObj.get('fromDate').touched">Fill
              from-date</small>
            <small class="err" *ngIf="isRangeDates">From-date should be less than To-date</small>

          </li>
          <li>
            <label for="birthday">To:</label>
            <input type="text" id="to" class="left" name="to" placeholder="MM/DD/YYYY" formControlName="endDate"
              [owlDateTimeTrigger]="dtRangeTo" [owlDateTime]="dtRangeTo">
            <owl-date-time #dtRangeTo [pickerType]="'calendar'"></owl-date-time>
            <small class="err" *ngIf="reqObj.get('endDate').hasError('required')&& reqObj.get('endDate').touched">Fill
              to-date</small>
          </li>
          <li>
            <button type="submit" class="reset" (click)="getappName(appTypeString)">RESET</button>

            <button type="submit"  data-dismiss="dropdown-menu" [ngClass]="!reqObj.valid ? 'isdis':'submit'" [disabled]="!reqObj.valid"
              (click)="appointmentDates(appTypeString)" id="btnFilter">SUBMIT</button>
          </li>
        </form>


      </ul>
    </div>

  </div>
  
</div>

<div class="container">
  
  <!-- <ng-container *ngIf="!loader">
    <img src="../../../../assets/resource/ayurls_loader.gif " alt="loader" class="img-loader">
  </ng-container> -->
  <ng-container *ngIf="loader && appoint_List?.content.length > 0">
    <div class="table-responsive">
    <table class="table table-striped">
      <thead>
        <tr>
          <th>Appointment ID </th>
          <th>Member Name </th>
          <!-- <th>Symptoms <span class="glyphicon glyphicon-arrow-up"></span></th> -->
          <th>Date </th>
          <th>Time</th>
          <th>Mode of Consult</th>
          <!-- <th>Services <span class="glyphicon glyphicon-arrow-up"></span></th> -->
          <th>Status</th>
          <th>Action</th>
          <th>Join</th>
          <!-- <th>Edit <span class="glyphicon glyphicon-arrow-up"></span></th> -->
          <!-- <th>Cancel Appoinment <span class="glyphicon glyphicon-arrow-up"></span></th> -->
        </tr>
      </thead>
      <tbody>
        <tr
          *ngFor="let list of appoint_List?.content|paginate: { itemsPerPage: 5, currentPage: p ,totalItems:appoint_List?.totalElements} ;let i=index">
          <td><a [routerLink]="['/doctor-appointment',list.appointmentId]">{{list.appointmentId}}</a></td>
          <td>{{list.patientName|titlecase}}</td>
          <!-- <td>cold</td> -->

          <td>{{(list.appointmentTime !='null')? (list.appointmentTime|date:'dd/MM/yyyy'):''}}</td>
          <td>{{(list.appointmentTime !='null')?(list.appointmentTime|date:'shortTime'):''}}</td>
          <td>{{list.modeOfConsultation}}</td>
          <td>{{list.status}}</td>
          <!-- <td>Dental Examination</td> -->

          <td>
            <ng-container *ngFor="let actionStatus of list?.action">
              <button type="button" class="accept"
                (click)="appointStatus(list.appointmentId,list?.patientName,actionStatus?.status)"
                *ngIf="actionStatus?.lable =='ACCEPT'">{{actionStatus?.lable}}</button>
              <button type="button" class="reject" data-toggle="modal" data-target="#myModal"
                (click)="appointStatus(list.appointmentId,list?.patientName)"
                *ngIf="actionStatus?.lable =='REJECT'">{{actionStatus?.lable}}
              </button>
              <button type="button" class="reschedule" data-toggle="modal" data-target="#myModal1"
                (click)="appointStatus(list.appointmentId,list?.patientName)"
                *ngIf="actionStatus?.lable =='RESCHEDULED'">
                {{actionStatus?.lable}}</button>
            </ng-container>
          </td>
          
          <td>
            <!-- [disabled]="!(list.appointmentDate == date && list.status == 'SCHEDULED')" -->
            <button type="button"   [ngClass]="(list.appointmentDate == date && list.status == 'SCHEDULED')?'btn-success':'disabledbtn'"
            [disabled]="!(list.appointmentDate == date && list.status == 'SCHEDULED')"
              (click)="joinMeeting(list.appointmentId)"  *ngIf="list.appointmentDate !='null'">Join</button>
          </td>
          <!-- <td> <span class="glyphicon glyphicon-edit"></span></td> -->
          <!-- <td class="cl">X</td> -->
        </tr>


      </tbody>
    </table>
  </div>
    <div class="modal" id="myModal">
      <div class="modal-dialog modal-sm">
        <div class="modal-content">

          <!-- Modal Header -->
          <div class="modal-header">
            <h4 class="modal-title">Reject</h4>
            <button type="button" class="close" (click)="reason.reset()" data-dismiss="modal">&times;</button>
          </div>

          <!-- Modal body -->
          <div class="modal-body">
            <p>ID: {{selectId}}</p>
            <p>Name: {{selectName}}</p>
            <textarea name="w3review" rows="4" [(ngModel)]="reason_text" #reason='ngModel' placeholder="write a reason"
              required>

            </textarea>

          </div>
          <!-- Modal footer -->
          <div class="modal-footer">
            <button type="button" class="btn btn-danger" data-dismiss="modal" [disabled]='!reason.valid'
              (click)="reqForReject(selectId,reason_text,'reject')">Reject</button>
          </div>

        </div>
      </div>
    </div>
    <div class="modal" id="myModal1">
      <div class="modal-dialog modal-sm" class="model5">
        <div class="modal-content">

          <!-- Modal Header -->
          <div class="modal-header">
            <h4 class="modal-title">Reschedule</h4>
            <button type="button" class="close" (click)="appointment.reset()" data-dismiss="modal">&times;</button>
          </div>

          <!-- Modal body -->
          <div class="modal-body">
            <p>ID: {{selectId}}</p>
            <p>Name:{{selectName}}</p>
            <!-- <input class="text"><span class="glyphicon glyphicon-calendar"></span> -->
            <input class="text" [(ngModel)]="appointmentTime"  placeholder="Select Date"
              #appointment='ngModel'   (click)="openModal(appointmentSchduler)"  required>
            <!-- <span [owlDateTimeTrigger]="dtPicker">
              <span class="glyphicon glyphicon-calendar"></span>
            </span>
            <owl-date-time #dtPicker [hour12Timer]="true" [stepMinute]="30" [startAt]="startAt"></owl-date-time> -->
          </div>

          <!-- Modal footer -->
          <div class="modal-footer">
            <button type="button" class="btn btn-danger" [disabled]="!appointment.valid" data-dismiss="modal"
              (click)="reqForReschedule(selectId,appointmentTime)">Reschedule</button>
          </div>

        </div>
      </div>
    </div>


    <!-- pagination -->
    <div class="text-center" *ngIf="appoint_List?.totalElements >5">
      <pagination-controls class="my-pagination" (pageChange)="getPagination(p=$event,appTypeString)"></pagination-controls>
      <!-- <ul class="pagination">
      <li><a href="">Prev</a></li>
      <li  class="active"><a href="">1</a></li>
      <li><a href="">2</a></li>
      <li><a href="">Next</a></li>
    
    </ul> -->
    </div>
  </ng-container>
  <ng-container *ngIf="loader && appoint_List?.content.length == 0">
    <div class="container row text-center ">
      <p class="norecord">
        No Records Found
      </p>
    </div>
  </ng-container>



</div>




  <ng-template #appointmentSchduler>
    <div class="calendar-container">
      <div class="row">
        <p class="col-md-4 text-left"></p>
        <h4 class="col-md-4 text-center title">Appointment Calendar</h4>
        <i (click)="modalService.hide()" class="bi bi-x-circle"></i>
        <!-- <button type="button" class="col-md-1 cancelBtn" (click)="modalService.hide()">cancel</button> -->
      </div>
      <div class="row mt-4">
        <div class="col-md-6 col-sm-6 col-xs-6 text-left">
          <h3 class="mt-0">{{ viewDate | calendarSchedulerDate:(view + 'ViewTitle'):locale:weekStartsOn:excludeDays:viewDays:startsWithToday }}</h3>
              <!-- <select #viewDayOptionSelect1 class="form-control d-none d-md-block d-xl-none" [(ngModel)]="viewDays" (change)="viewDaysOptionChanged(viewDayOptionSelect1.value)">
                  <option [value]="1">Un giorno</option>
                  <option [value]="3">Tre giorni</option>
                  <option [value]="7">Una settimana</option>
              </select> -->
  
        </div>
        <div class="col-md-6 col-sm-6 col-xs-6 margintop text-right">
          <div class="row ">
            <div class="col-6 d-md-none d-xl-flex col-xl-6 valign-center text-right">
                <!-- <select #viewDayOptionSelect2 class="form-control m-1" [ngModel]="viewDays" (change)="viewDaysOptionChanged(viewDayOptionSelect2.value)">
                    <option [value]="1">Un giorno</option>
                    <option [value]="3">Tre giorni</option>
                    <option [value]="7">Una settimana</option>
                </select> -->
            </div>
            <div class="col-6 col-md-12 col-xl-6">
                <div class="btn-group m-1" role="group">
                    <button type="button" class="btn btn-primary btnFont"
                            mwlCalendarPreviousView
                            [view]="view"
                            [(viewDate)]="viewDate"
                            [daysInWeek]="viewDays"
                            [excludeDays]="excludeDays"
                            [disabled]="prevBtnDisabled"
                            (viewDateChange)="dateOrViewChanged()"
                            (click)="getSchedular(viewDate)">
                        <span class="valign-center">
                            <i 
                                class="bi bi-chevron-left">Previous</i>
                        </span>
                    </button>
                    <button type="button" class="btn btn-primary btnFont"
                            mwlCalendarToday
                            [(viewDate)]="viewDate"
                            (viewDateChange)="dateOrViewChanged()"
                            (click)="getSchedular(viewDate)">
                        <span class="valign-center">
                            <i 
                                class="">Today</i>
                        </span>
                    </button>
                    <button type="button" class="btn btn-primary btnFont"
                            mwlCalendarNextView
                            [view]="view"
                            [(viewDate)]="viewDate"
                            [daysInWeek]="viewDays"
                            [excludeDays]="excludeDays"
                            [disabled]="nextBtnDisabled"
                            (viewDateChange)="dateOrViewChanged()"
                            (click)="getSchedular(viewDate)"
                            >
  
                        <span class="valign-center">
                            <i 
                                class="bi bi-chevron-right">Next</i>
                        </span>
                    </button>
                </div>
            </div>
        </div>
        </div>
      </div>
     
      <div>
        <calendar-scheduler-view 
                                  [viewDays]="viewDays"
                                  [viewDate]="viewDate"
                                  [events]="events"
                                  [locale]="locale"                               
                                  [responsive]="false"
                                  [weekStartsOn]="weekStartsOn"
                                  [excludeDays]="excludeDays"
                                  [startsWithToday]="startsWithToday"
                                  [hourSegments]="hourSegments"
                                  [dayStartHour]="dayStartHour"
                                  [dayEndHour]="dayEndHour"
                                  [dayModifier]="dayModifier"
                                  [hourModifier]="hourModifier"
                                  [segmentModifier]="segmentModifier"
                                  [eventModifier]="eventModifier"
                                  [showEventActions]="true"
                                  [showSegmentHour]="true"
                                  [zoomEventOnHover]="true"
                                  (viewDaysChanged)="viewDaysChanged($event)"
                                  (dayHeaderClicked)="dayHeaderClicked($event.day)"
                                  (segmentClicked)="segmentClicked('Clicked', $event.segment)"
                                  (eventClicked)="eventClicked('Clicked', $event.event)"
                                  (eventTimesChanged)="eventTimesChanged($event)"
                                  [refresh]="refresh"
                                  >
  
        </calendar-scheduler-view>
      </div>
  
  
    </div>
  
  
   <!-- (hourClicked)="hourClicked($event.hour)" -->
    
  </ng-template>

